import { Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay, map, retry } from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { MyobServiceInvoice } from './../../../models/myob-service-invoice.model';
import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { SubjectInvoice } from './../../../shared/models/subjectInvoice.model';
import { Brand } from './../../../shared/models/brand.model';




@Component({
  selector: 'app-myob-api-customer-supplier-sync-tools-widget',
  templateUrl: './myob-api-customer-supplier-sync-tools-widget.component.html',
  styleUrls: ['./myob-api-customer-supplier-sync-tools-widget.component.css']
})
export class MyobApiCustomerSupplierSyncToolsWidgetComponent implements OnInit, OnChanges {



  @Input() sent_data?: any; // not used
       // setup as observable?
       @Input() item_id?; // impliments on changes.
       @Input() invoice_id?; // impliments on changes.
       @Input() brand_id?; // impliments on changes.
       @Input() UID?; // impliments on changes.
       @Input() item_data?; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = ''; // side | abstract | full | check
       @Input() show_myob_checker? = '1'; // 1 | 0
       @Input() show_count? = '0'; // 1 | 0
       @Input() DisplayID?;
    
       job: Object;
       job_id;
    sessionUserId: any;
    sessionUsername: any;
    sessionBrandId: any;
    all_router_details: string;
  
// Grid Vars
public data: DataManager;
public data_subjects: DataManager;
public pageSettings: Object;
public pageOptions = { pageSize: 100 }; 
public filterOptions: FilterSettingsModel;
public formatOptions: Object;
// public filterOptions: FilterSettingsModel;
public filter : IFilter;
public toolbarOptions: ToolbarItems[];
@ViewChild('grid')
public grid: GridComponent;
public groupOptions: GroupSettingsModel;
public templateOptionsDate: IFilterUI;
public elem1: HTMLElement;
public datePickerObj: DatePicker;
subjects_urgent: any;
formatoptions: { type: string; format: string; };
dateFormat: string;
sortOptions: { columns: { field: string; direction: string; }[]; };

today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
// today_set = new Date(); // sets todays date
// today = this.datepipe.transform(this.today_set, 'dd/MM/yyyy h:mm a'); // formats date for comparison

initialPage: { pageSize: number; };
 invoices: any;
 modalRef: any;
 myobInvoiceCreatedData: any;
 myobInvoiceListMapped: any;
 set_RowVersion: any;
 brand: any;
 brandData: any;
 data_invoice: any = MyobServiceInvoice;
 myobInvoices: Object;
 arrCase: object[];
 Items: any;
 myobInvoiceDeleteData: Object;
 myobInvoice: Object;
 invoiceItem: any;
 invoiceItemsList: any = SubjectInvoiceItem;
 
 myob_account_codes: Object;
 myob_tax_codes: Object;
 myobInvoiceUpdateData: any;
 myobInvoiceUpdatedData: any;

 invoice_model: SubjectInvoice = new SubjectInvoice();
 invoice_item_model: any = SubjectInvoiceItem;
 invoiceItemUpdateList: any;
 new_line: {};
  subject: Object;
  subject_number: any;
  brand_invoice_id: any;
  invoice_job_type_id: any;
  invoice_brand: Object;
  owner_brand: Object;
  invoice_status: Object;
  invoice_status_name: any;
  invoice_status_var: any;
  invoice_payment_status: Object;
  invoice_payment_status_name: any;
  invoice_payment_status_var: any;
  invoice_communication_status: Object;
  invoice_communication_status_name: any;
  invoice_communication_status_var: any;
  invoice_status_all: Object;
  invoice_payment_status_all: Object;
  invoice_communication_status_all: Object;
  subject_id: any;
  invoice_number: any;
  is_job_invoice_var: any;

  open_jobs_count: any;
  myobCustomers: Object;

  myobCustomerCreatedData: any;
  brand_types: any;
  users: any;
  usersPrimary: any;
  job_table_clients: any;
  btLocalRecord: any;
  changeObject: any;
  userLocalRecord: any;
  job_table_clients3: any;
  UID_new_customer: any;
  returned_update: Object;
  myobCustomerDeleteData: Object;
  myobCustomerUpdateData: Object;
  customerItem: any;
  myobContactListMapped: any;
  myobCustomer: Object;
  IsIndividual: any;
  brand_data: any;
  brand_data_item: any = Brand;
  work_orders: any;
  work_order_model: any;
  count_work_orders: any = 0;
  myob_checker: any;
  count_invoices: number;
  myob_response;



  reconnect_myob_brand: Object;
  response_from_node: string;
  response_from_node_raw: any;
  error_message: any;
  error_name: any;
  full_response_data: any;
  data_sent: any;
  data_sent_id: any;
  data_sent_DisplayID: any;
  full_response_status: any;
  full_response_header
  full_response_headers: any;
  full_response: any;


     // sees if there is a change in myCount
     @Output() change: EventEmitter<any> = new EventEmitter<any>();
     // New event emitter to show the results of api calls to other modules from this component as sendResponse() results.. set response_from_node
       @Output('sendResponse') sendResponse: EventEmitter<any> = new EventEmitter();
       @Output() test_message: EventEmitter<any> = new EventEmitter<any>();

       error_message_standard: any;
  data_sent_passed: any;
  data_sent_CompanyName: any;

  // test_message:any;

  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,  public gfunc: GlobalFunctionsService,
   public toastr: HotToastService,
  //  vcr: ViewContainerRef,
  ) { 
    // this.toastr.setRootViewContainerRef(vcr);


 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

      // Grid Options
      this.toolbarOptions = ['Search'];
      this.initialPage = { pageSize: 40 };
      this.filterOptions = {
        type: 'Menu'
      };
      // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
      this.groupOptions = { }; // sets auto grouping for the grid
      this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
      this.dateFormat = 'dd/MM/yyyy hh:mm a';
      //this.filter = { params: { format: this.dateFormat } };
      this.sortOptions = { columns: [{ field: 'name', direction: 'Ascending' } ] };
  }



 // check for changes. to load data.
 ngOnChanges(changes) {
  if (changes.item_id) {
    // deal with asynchronous Observable result
    this.brand_id = changes.item_id.currentValue;
    this.UID = changes.UID.currentValue;
    // this.getJob(this.job_id);
  }


  if (changes.brand_id) {
    this.brand_id = changes.brand_id.currentValue;

this.getBrand(this.brand_id);
this.getBrandBrandTypes();
this.getBrandWorkOrders(this.brand_id);
// run myob checker...
this.myob_response = true;
// this.myobChecker();

   // load some myob stuff
  //  this.getMyobTaxCodes(); // load for merge variables arrays
  //  this.getMyobAccountCodes();
  }



}






  ngOnInit() {
// this.getBrand(this.brand_id);
// this.getBrandBrandTypes();

  }



  // :: Grid Functions


// https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);

   // this.search_results = pdfdata.records; // need this if a grouping is set.
  /*   this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

};


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

  // :: Grid Functions

  


    refreshGrid(){ // refresh the databutton
      // this.loadList(this.doc_id);
      this.grid.refresh();
    };

// need to change this below
editBrand(model){
  // model.job_id = this.job_id;
   this._demoService.updateBrand(model).subscribe(
     data => {  // this.trace_candidate_update = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Company Updated');
     this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
     },
     error => {
      // console.error('Error saving Event!');
       this.toastr.error('Error Updating Brand');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
 );}



// : Begining of Myob Calls


 createMyobSupplierModel(model){
  this.gfunc.myobChecker();
  // if (confirm('We are about to Sync this Business/Agent with MYOB as a Supplier, Are you Sure?')) {
  // :: Need to create a new customer model based on myob defaul and required fields for insert of new customer
                let data2 = {
                  'CompanyName': model.name,
                  'LastName': model.surname,
                  'FirstName': model.name,
                  'IsIndividual': false,
                  'DisplayID': 'TSA' + model.brand_id,
                  'IsActive' : true,

                  'Addresses' : [
                    {
                    'Location' : 1,
                    'Street' : model.address_1 + ' ' + model.address_2 ,
                    'City' : model.suburb,
                    'State' : model.state,
                    'PostCode' : model.postcode,
                    'Country' : model.country,
                    'Phone1' : model.phone,
                    'Phone2' : '',
                    'Phone3' : '',
                    'Fax' : model.fax,
                    // 'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
                    'Email' : model.email, // supplier/agent email address for myob
                    'Website' : model.website,
                    'ContactName' : '',
                    'Salutation' : ''
                    },
                    {
                      'Location' : 2,
                      'Street' : model.postal_address_1 + ' ' + model.postal_address_2,
                      'City' : model.postal_suburb,
                      'State' : model.postal_state,
                      'PostCode' : model.postal_postcode,
                      'Country' : model.postal_country,
                      'Phone1' : model.phone,
                      'Phone2' : '',
                      'Phone3' : '',
                      'Fax' : model.fax,
                     //  'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
                    'Email' : model.email, // if an agent
                      'Website' : model.website,
                      'ContactName' : '',
                      'Salutation' : ''
                      }
                    ],
                    'Notes' : model.brand_notes,

                    'CustomField1' : {
                      'Label' : 'brand_id',
                      'Value' : model.brand_id
                      },
                  // 'SellingDetails': {
                  //     'SaleLayout' : 'NoDefault',
                  //     'PrintedForm' : 'null',
                  //     'InvoiceDelivery' : 'Print',
                  //     'ABN' : '',
                  //     'TaxCode': {
                  //       'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe',
                  //       'Code': 'GST'
                  // tslint:disable-next-line:max-line-length
                  //       // "URI": "https://arl2.api.myob.com/accountright/8449d6c9-2fdc-412a-8412-b6c0a058beba/GeneralLedger/TaxCode/8d273078-fe1d-4c16-b318-ec7a2b7fb2fe"
                  //     },

                  'BuyingDetails': {
                    'ABN' : model.abn,
                    'TaxCode': {
                      'UID': this.gfunc.myob_TaxCode
                    },
                      'FreightTaxCode': {
                        'UID': this.gfunc.myob_FreightTaxCode,
                        // 'Code': 'GST'
                      }
                    }
                  // "UseCustomerTaxCode": false
                  };


    this._demoService.createMyobSupplier(data2).pipe(
      this.toastr.observe({
         loading: 'Updating...Pushing...Saving',
         success: '🚀',
         error: '😡'
      })
    )
    .subscribe(
    data => { this.myobCustomerCreatedData = data;
      let res = data[0];
      let new_data_object = JSON.parse(this.myobCustomerCreatedData);

      // console.log('new_data date: ' + new_data_object.date);
      // console.log('new_data Location ' + new_data_object.location);
      // remove the last 25 chars to get the inserted id.
      // get the length of the string and then splice 25 chars less from the total length.
      let location_string = new_data_object.location;
      // let data_object_length = location_string.length;
      // let start_from = data_object_length - 25;
      // let data_object_splice = location_string.slice( start_from , data_object_length);
      // this.UID_new_customer = data_object_splice;
      // console.log('Last inserted myobID: ' + this.UID_new_customer);

      // get everything after last dash 
      let slug = location_string.split('/').pop(); // 2020
      console.log('UUID slug: ' + slug);

      model.myob_id = slug;
      model.sync_with_myob = 1;

      // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.

                // need to pass the brand model here as its updatting the full SOP brand details.
                this._demoService.getMyobSupplierMapped(slug, model)
                .pipe(
                  retry(0), // you retry 3 times
                  delay(1200) // each retry will start after 1 second,
               )
                .subscribe(
                   data4 => {
                    console.log(data4);
                    res = data4[0];
                  // many
                    // this.myobContactListMapped = data.data;
                  //single
                    this.myobContactListMapped = data4;
                  // Set the returned Variables Reququied for Update of a Myob Customer.
                  console.log('UID: ' +  data4.UID);
                  console.log('LastModified: ' + data4.LastModified);
                  console.log('RowVersion: ' + data4.RowVersion);
                  // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                  // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);

                  this.set_RowVersion = data4.RowVersion;
                  this.IsIndividual = data4.IsIndividual;

                  model.IsIndividual = data4.IsIndividual;
                  // model.SaleLayout = data4.SellingDetails.SaleLayout;
                  // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                  model.TaxCode = data4.BuyingDetails.TaxCode.UID;
                  model.FreightTaxCode = data4.BuyingDetails.FreightTaxCode.UID;

                  model.RowVersion = data4.RowVersion;
                  model.myob_customer_array = JSON.stringify(data4);

                  this.editBrand(model);
                  // this.refreshGrid(); (Only needed if using the grid.)
                  this.toastr.info('Supplier/Agent Upgraded In TSA');
                },
                // Absolute and proper way to return myob errors.... 14/02/24
                err => {
                  // console.error('Error saving Event!');
                  //  this.toastr.error('Error Updating Agent Myob Details');
                  // console.log(error.error);

                  console.error(err)
                  // Need to set some error varibles
                  this.error_message = err.error.error_message;
                  this.error_message_standard = err.error.error_message_standard;
                  this.error_name = err.error.error_name;
                  this.full_response_data = err.error.full_response_data;
                  this.data_sent = err.error.data_sent;
                  this.data_sent_id = err.error.data_sent_invoice_id;
            
                 
            
                  this.response_from_node = JSON.stringify(err)
                  this.response_from_node_raw = err;
                  this.sendResponse.emit(this.response_from_node);
                  // console.log('FullRespoonse Error Inside Tools 4: ' + this.response_from_node)
                  // this.test_message = this.response_from_node; // could be as simple as this?
                  return(this.response_from_node = JSON.stringify(err)); // do this so other componets get

                 });

                 model.IsIndividual = this.IsIndividual;
                 model.RowVersion = this.set_RowVersion;

                      //  model.RowVersion = this.set_RowVersion;
                      //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);

                      // console.log(this.myobCustomerCreatedData.location);
                      // // https://www.concretepage.com/questions/577
                      //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
                      //  // console.log(this.arrCase);
                      //  this.Items = data['Items'] ;

    },
    (err) => {
      // this.toastr.error('You need to login to MYOB again, Connection lost!');
      console.error(err)
      // Need to set some error varibles
      this.error_message = err.error.error_message;
      this.error_message_standard = err.error.error_message_standard;
      this.error_name = err.error.error_name;
      this.full_response_data = err.error.full_response_data;
      this.data_sent = err.error.data_sent;
      this.data_sent_id = err.error.data_sent_invoice_id;

     
      this.data_sent_passed = JSON.parse(err.error.data_sent);
      this.response_from_node = JSON.stringify(err)
      this.response_from_node_raw = err;
      this.sendResponse.emit(this.response_from_node);
      // console.log('FullRespoonse Error Inside Tools 4: ' + this.response_from_node)
      // this.test_message = this.response_from_node; // could be as simple as this?
      return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
    },
    // () => console.log('done loading Trace Types')
  );

  // }; // end confirm

};



// Delete Myob Company
deleteMyobSupplierModel(model){
  this.gfunc.myobChecker();
  if (confirm('This will delete this company supplier from Myob. We cannot undo this, Are you Sure?')) {
      this._demoService.deleteMyobSupplier(model)
          .pipe(
      retry(0), // you retry 3 times
      delay(1200) // each retry will start after 1 second,
    ).subscribe(
    data => { this.myobCustomerDeleteData = data;
      let res = data[0];
          model.myob_id = null;
          // model.sync_with_myob = 0;
                    // model.sync_with_myob = 0; 
                    // Set these from the global setting so I dont have to reset every time.
                    model.TaxCode = this.gfunc.myob_TaxCode;
                    model.FreightTaxCode= this.gfunc.myob_FreightTaxCode;
          model.RowVersion = null;
      this.editBrand(model);
      //  this.refreshGrid();
      this.toastr.success('Brand Deleted and Un-Linked with Myob');
    },
    err => {
      this.toastr.error('Supplier deleting error with Myob');
     // console.error(err);
    },
    // () => console.log('done loading Trace Types')
  );
  }; // end confirm
};


// Update Company


updateMyobSupplerModel1(UID, model) {
    // get lateset row vrs first
     console.log('Supplier Update Model: ' + JSON.stringify(model));
     // :: In case version was changed in MYOB.
    
    //  this.lookupSupplierUpdateBrand(UID, model); -- Why do I do this twice?

    this.gfunc.myobChecker()
    this.updateMyobSupplierModel2(model);
}



updateMyobSupplierModel2(model) {
      if (confirm('We are about to Sync this Business with MYOB and update the myob data, Are you Sure?')) {

        const data_test = {
          'UID': model.myob_id,
          'CompanyName': model.name,
          'LastName': '',
          'FirstName': '',
          'IsIndividual': false,
          'DisplayID': 'TSA' + model.brand_id,
          'Addresses' : [
            {
            'Location' : 1,
            'Street' : model.adddress_1 + ' ' + model.adddress_2,
            'City' : model.suburb,
            'State' : model.state,
            'PostCode' : model.postcode,
            'Country' : model.country,
            'Phone1' : model.phone,
            'Phone2' : '',
            'Phone3' : '',
            'Fax' : model.fax,
            // 'Email' : model.accounts_email_address, // set as the accounts email Address always for myob
            'Email' : model.email, // set as the accounts email Address always for myob
            'Website' : model.website,
            'ContactName' : '',
            'Salutation' : ''
            },
            {
              'Location' : 2,
              'Street' : model.postal_address_1 + ' ' + model.postal_adddress_2,
              'City' : model.postal_suburb,
              'State' : model.postal_state,
              'PostCode' : model.postal_postcode,
              'Country' : model.postal_country,
              'Phone1' : model.phone,
              'Phone2' : '',
              'Phone3' : '',
              'Fax' : model.fax,
              'Email' : model.email, // set as the accounts email Address always for myob
              'Website' : model.website,
              'ContactName' : '',
              'Salutation' : ''
              }
            ],
            'Notes' : model.brand_notes,

            'CustomField1' : {
              'Label' : 'brand_id',
              'Value' : model.brand_id
              },

          'BuyingDetails': {
            'ABN' : model.abn,
            'TaxCode': {
              'UID': this.gfunc.myob_TaxCode
            },
            'FreightTaxCode': {
              'UID': this.gfunc.myob_FreightTaxCode
            }
          },
          'RowVersion': model.RowVersion,
        };

                // create the record and then update local Brand/Agent Details
                this._demoService.updateMyobSupplier(data_test).pipe(
                  this.toastr.observe({
                     loading: 'Updating...Pushing...Saving',
                     success: '🚀',
                     error: '😡'
                  })
                ).subscribe(
                      data => { this.myobCustomerUpdateData = data;
                        let res = data[0];

                        // turned below into a function to refresh all the row versions again on save. (just in case.)
                        this.lookupSupplierUpdateBrand(model.myob_id, model);
                        // this.toastr.success('Agent Supplier Details updated with Myob');
                      },
                      // err => {
                      //   // this.toastr.error('You need to login to MYOB again, Connection lost!');
                      // console.error(err);
                      // },

                     (err) => {
                        this.toastr.error('We encounted issues please try again.', err.error);
                        console.error(err);
                        this.response_from_node = JSON.stringify(err);
                        this.response_from_node_raw = err;
                          
                        // Need to set some error varibles
                          this.error_message = err.error.error_message;
                          this.error_name = err.error.error_name;
                          this.full_response_data = err.error.full_response_data;
                          this.data_sent = err.error.data_sent;
                          this.data_sent_id = err.error.data_sent.CustomField1.Value;
                          this.data_sent_DisplayID = err.error.data_sent.DisplayID;
                          this.data_sent_CompanyName = err.error.data_sent?.CompanyName;
                        
                        
                          this.full_response_status = err.error.full_response_staus;
                          this.full_response_headers = err.error.full_response_headers;
                          this.full_response = err.error.full_response; 
                          })

                      // () => console.log('done loading Trace Types')
                    

      }; // end confirm
    };


// Run ths function after any update or get latest row versions
// refreshes Row Version (Mob Lookup Versions)
lookupSupplierUpdateBrand(UID, model) {
  this._demoService.getMyobSupplierMapped(UID, model)
  .pipe(
    retry(0), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 )
  .subscribe(
    data4 => {
     console.log(data4);
     let res = data4[0];
     this.myobContactListMapped = data4;
   this.set_RowVersion = data4.RowVersion;
   this.IsIndividual = data4.IsIndividual;
   model.IsIndividual = data4.IsIndividual;
  //  model.SaleLayout = data4.SellingDetails.SaleLayout;
  //  model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
  //  model.TaxCode = data4.SellingDetails.TaxCode.UID;
  //  model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
  // model.TaxCode = data4.TaxCode;
  // model.FreightTaxCode = data4.FreightTaxCode;
  // model.RowVersion = data4.RowVersion;
  // model.myob_customer_array = JSON.stringify(data4);

  // A MUST!!!!

  // Updated 2023 feb was missing details after update... push of buttons.
  model.IsIndividual = data4.IsIndividual;
  model.SaleLayout = data4.BuyingDetails.SaleLayout;
  model.InvoiceDelivery = data4.BuyingDetails.InvoiceDelivery;
  model.TaxCode = data4.BuyingDetails.TaxCode.UID;
  model.FreightTaxCode = data4.BuyingDetails.FreightTaxCode.UID;
  model.RowVersion = data4.RowVersion;
  model.myob_customer_array = JSON.stringify(data4);




   this.editBrand(model); // update the brands rowsversions etc
  //  this.refreshGrid();
   this.toastr.info('Supplier RowVrs Updated In TSA');
 },
 error => {
   // console.error('Error saving Event!');
    this.toastr.error('Error Updating Agent RowsVrs from Myob Details');
   console.log(error.error);
  });
}; // end loopup and update function








// New way of rendering table data
mapJobTableLiveClients() {

  this.getBrandBrandTypes();
  this.getUsers();
  
  
  this.http.get<any>(this.gfunc.apiURL + 'api/brands/get/' + this.brand_id)
  // this.http.get<any>(this.gfunc.apiURL + 'api/brands/clients')
 .pipe(map(data => {
  // do your transformations
  this.job_table_clients = data;

  this.job_table_clients.forEach(element => {
    element.primary_contact = ''; // removed undefined from table

/*
// local Client Name
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/

// commented out so that brand_type_id do not change to a word.
// this.btLocalRecord = this.brand_types.filter(c => c.brand_type_id === element.brand_type_id);
// this.changeObject = Object.assign(this.btLocalRecord);
//   element.brand_type_id  = this.changeObject[0].brand_type_name;

// get user counts per brand - Changes the actual Brand Type ID>...
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount = this.changeObject.length;
element.contacts  = this.changeObject.length;



// get user counts per brand
this.userLocalRecord = this.users.filter(c => c.brand_id === element.brand_id && c.is_primary_contact == 1);
this.changeObject = Object.assign(this.userLocalRecord);
let recordCount2 = this.changeObject.length;
// element.contacts  = this.changeObject.length;
// need to filter this element objects of users to get the primary contact.
if (recordCount2 < 1){
  element.primary_contact = '-';
}else{
  for (let i = 0; i < recordCount2; i++) {
    element.primary_contact  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
} // end loop
}// end if


}); // end for each of all


return this.job_table_clients3;
})
 ) // end pipe
  .subscribe(results => this.job_table_clients3 = results
  );

}





getBrandBrandTypes(){
  this._demoService.getBrandBrandTypes().subscribe(
    data => { this.brand_types = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getUsers() {
  this._demoService.getUsers().subscribe(
    data => { this.users = data;
      this.usersPrimary = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


brandView(brand_id) {
  this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
}

brandEdit(brand_id) {
  this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
}



public getMyobCustomer(UID){
    this._demoService.getMyobCustomer(UID).subscribe(
      data => { this.myobCustomer = data;
        let res = data[0];
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.customerItem = data['Item'] ;
        // console.log(this.customerItem);
        // this.Address = this.Items['Address'];
      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading')
    );
  }



  // the declared vars
  //  myobContactListMapped: MyobContact[];
  getMyobCustomerMapped(UID) {
   this._demoService.getMyobCustomerMapped(UID)
    .subscribe((data:any) => {
       console.log(data);
     // many
       // this.myobContactListMapped = data.data;
     //single
       this.myobContactListMapped = data.data;
    });
  }




  private getBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.brand_data = data;
       
        this.brand_data_item = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Client Report',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Client Report',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }


  getMyobAccountCodes() {
    this._demoService.getMyobAccountCodes().subscribe(
       data => { this.myob_account_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getMyobTaxCodes() {
    this._demoService.getMyobTaxCodes().subscribe(
       data => { this.myob_tax_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   myobChecker() {
    this._demoService.myobChecker().subscribe(
       data => { this.myob_checker = data;
        // let res = data[0];
        // this.toastr.success('Myob Connections Active!... functions allowed');
  // console.log('Connected: ', JSON.stringify(this.myob_checker));
  this.myob_response = true;
      },
       err => (
        // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
        this.myob_response = false,
        console.error(err)
        
       ),
       // () => console.log('done loading Trace Types')
     );
   }



   getBrandInvoices(to_brand_id) {
    this._demoService.getBrandInvoices(to_brand_id).subscribe(
       data => { this.invoices = data; 
        // maps to interface.(invoice_mode)
      this.invoice_model = this.invoices;

       // Count Invoices and Determin If can delete.
       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
       this.count_invoices = count_of_items;
      }, // make the same data call for all
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getBrandWorkOrders(agent_id) {
    this._demoService.getBrandWorkOrders(agent_id).subscribe(
       data => { this.work_orders = data; 
        // maps to interface.(invoice_mode)
        let res = data[0]
      this.work_order_model = this.work_orders;
      
      // Count Work Orders and Determin If can delete.
      let newArr = data;
      let  count_of_items = Object.keys(newArr).length;
      this.count_work_orders = count_of_items;
      
      }, // make the same data call for all
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }




   reConnectMyobSupplierBrand(DisplayID, brand_id) {
    this.gfunc.myobChecker();
    this.http.get(this.gfunc.sopNodeURL + '/rowVersionsContactsSuppliers/' + DisplayID + '/' + brand_id  )
    .pipe(
      this.toastr.observe({
        loading: '---',
        success: '🚀',
        error: '...😡...'
     })
     )
    .pipe(
      retry(0), // you retry 3 times
      delay(1500) // each retry will start after 1 second,
   ).subscribe(
    data => { this.reconnect_myob_brand = data;
  
      let res = data[0];
    // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
    
    this.response_from_node = JSON.stringify(data);

  },
  err => {
  this.toastr.error('We encounted issues please try again.', err.error);
  console.error(err);
  this.response_from_node = JSON.stringify(err);
  this.response_from_node_raw = err;
    
  // Need to set some error varibles
    this.error_message = err.error.error_message;
    this.error_name = err.error.error_name;
    this.full_response_data = err.error.full_response_data;
    this.data_sent = err.error.data_sent;
    this.data_sent_id = err.error.data_sent.CustomField1.Value;
    this.data_sent_DisplayID = err.error.data_sent.DisplayID;
    this.data_sent_passed = JSON.parse(err.error.data_sent);
  
    this.full_response_status = err.error.full_response_staus;
    this.full_response_headers = err.error.full_response_headers;
    this.full_response = err.error.full_response;
  
  
  
    
  
  });
  }


}
